import React from 'react'
import { withRouter } from 'react-router-dom'

import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'

import NavBar from '../../componentes/Navbar'
import Progresso from '../../componentes/Progresso'
import UsuarioService from '../../app/service/UsuarioService'
import UsuarioGrupoTrabalhoService from '../../app/service/UsuarioGrupoTrabalhoService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

class Usuarios extends React.Component {

  constructor(props) {
    super(props);

    this.usuarioService = new UsuarioService();
    this.usuarioGrupoTrabalhoService = new UsuarioGrupoTrabalhoService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();

    this.state = {
      classeDiv: 'hide',
      usuarios: [],
      visible: '',
      codigo: '',
      consulta: '',
      //Consulta dos Grupos de Trabaho
      displayBasic: '',
      usuarioGrupo: '',
      gruposTrabalho: [],
      gruposSemUsuario: [],
      selectGrupo: null,
      usuario: null
    };

    this.acoes = this.acoes.bind(this);
    this.accept = this.accept.bind(this);
    this.onGrupoChange = this.onGrupoChange.bind(this);
    this.renderFooterGruposUsuarios = this.renderFooterGruposUsuarios.bind(this);
    this.excluirUsuario = this.excluirUsuario.bind(this);
    this.acoesGrupos = this.acoesGrupos.bind(this);
  }

  async confirmaExclusao(usuario) {
    this.setState({codigo: usuario.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o Usuário selecionado?',
        header: 'Exclusão de Usuário',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  accept() {
    this.excluirUsuario();
  }

  excluirUsuario = async () => {
    this.setState({classeDiv: 'show'})
    await this.usuarioService.excluirUsuario(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Usuários', detail:'Usuário excluído com sucesso', life: 4000});
        this.listarUsuarios();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Usuários', detail:`${this.state.detail}`, life: 4000});
        this.setState({classeDiv: 'hide'})
      });

      this.setState({classeDiv: 'hide'});
  }

  listarUsuarios = async () => {
    this.setState({classeDiv: 'show'});
    const usuarioLogado = this.context.usuarioAutenticado;
    
    const filtroUsuario = {
      consulta: this.state.consulta,
      empresa: usuarioLogado.empresa.codigo 
    }
    
    await this.usuarioService.listarUsuario(filtroUsuario)
      .then(response => {
        this.setState({usuarios: response.data})
      }).catch(error => {
        this.setState({classeDiv: 'hide'});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Usuários', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({classeDiv: 'hide'});
  }

  novoUsuario = () => {
    this.props.history.push('/cadastroUsuario')
  }

  componentDidMount(){
    this.listarUsuarios();
  }

  exibirGruposTrabalho(usuario) {
    this.setState({usuarioGrupo: usuario.nome});
    this.setState({usuario: usuario});
    this.listarGruposSemUsuario(usuario);
    this.listarGruposUsuarios(usuario);
    this.abrirModaUsuariosGrupo('displayBasic');
  }

  incluirGrupoUsuario = () => {

    if(this.state.selectGrupo == null) {
      this.toast.show({severity:'error', summary: 'Usuários', detail:'Informe o Grupo de Trabalho', life: 4000});
      return false;
    }

    this.usuarioGrupoTrabalhoService.incluirUsuarioGrupo({
      grupo: this.state.selectGrupo,
      usuario: this.state.usuario
    }).then(respnse => {
      this.listarGruposUsuarios(this.state.usuario);
      this.listarGruposSemUsuario(this.state.usuario);
      this.setState({selectGrupo: null});
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Usuários', detail:`${this.state.detail}`, life: 4000});
    })
  }

  async excluirGrupoUsuario(usuario){
    await this.usuarioGrupoTrabalhoService.excluirUsuarioGrupo(usuario.codigo)
      .then(response => {
        this.listarGruposUsuarios(usuario.usuario);
        this.listarGruposSemUsuario(usuario.usuario);
        this.setState({selectGrupo: null});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Usuários', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarGruposUsuarios = (usuario) => {
    this.usuarioGrupoTrabalhoService.listarGruposPorUsuario(usuario.codigo)
      .then(response => {
        this.setState({gruposTrabalho: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Usuários', detail:'Ocorreu um erro ao listar Grupos de Trabalho por Usuário', life: 4000});
      })
  }

  listarGruposSemUsuario = async (usuario) => {
    
    const usuarioLogado = this.context.usuarioAutenticado

    const filtroGrupo = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuario.codigo
    }

    await this.grupoTrabalhoService.listarGruposSemUsuario(filtroGrupo)
      .then(response => {
        this.setState({gruposSemUsuario: response.data});
      }).catch(error => {
        console.log('Nenhum grupos encontrado')
      })
  }

  async onGrupoChange(e) {
    await this.setState({selectGrupo: e.value});
    this.incluirGrupoUsuario();
  }

  abrirModaUsuariosGrupo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  acoes(rowData) {
    return (
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.editar(rowData)}
                tooltip="Editar Usuário" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-sitemap" className="p-button-rounded p-button-text"
                tooltip="Grupos acessíveis"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.exibirGruposTrabalho(rowData)}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Usuário" 
                tooltipOptions={{position: 'top'}}/>

      </React.Fragment>
    );
  }

  acoesGrupos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Grupo de Trabalho"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.excluirGrupoUsuario(rowData)}/>
      </React.Fragment>
    );
  }

  renderFooterGruposUsuarios(name) {
    return (
        <div>
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  editar(usuarioEditar) {
    this.props.history.push(`/editarUsuario/${usuarioEditar.codigo}`);
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
        {/**Consultar Grupos por usuário e adicionar */}     
        <Dialog header={`Grupos de Trabalho do Usuário - (${this.state.usuarioGrupo})`}
                  visible={this.state.displayBasic} 
                  style={{ width: '40vw' }} 
                  footer={this.renderFooterGruposUsuarios('displayBasic')} 
                  onHide={() => this.fecharModalCadastro('displayBasic')}>
              <div class="row">
                <div class="col-md-8">
                    <div className="p-fluid">
                        <div className="p-field">
                            <label htmlFor="usuarioGrupo">Grupos de Trabalho(Adicionar)</label>
                            <Dropdown value={this.state.selectGrupo} options={this.state.gruposSemUsuario}
                                    onChange={this.onGrupoChange}
                                    optionLabel="nome" filter showClear filterBy="nome" 
                                    placeholder="Selecione o usuario"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                    </div>
                </div>
              </div>
              <br></br>
              <div className="row">
                <div class="col-md-12">
                  <DataTable value={this.state.gruposTrabalho}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={5}
                      emptyMessage="Nenhum grupo para este usuário">
                      <Column field="grupo.nome" header="Grupo"></Column>
                      <Column body={this.acoesGrupos} exportable={false} style={{ minWidth: '8rem' }}header="Ações"/>
                  </DataTable>
                </div>
              </div>
          </Dialog>  
          <section className="content-header">
              <div className="container-fluid">
              <div className="row">
                  <div className="col-md-12">
                    <div className="card card-primary card-outline">
                      <div className="card-header">
                        <h3 className="card-title">
                          <i className="fas fa-users"></i>
                          <span> Usuários</span>
                        </h3>  
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-5">
                            <span className="input-group">
                              <button type="button" className="btn btn-primary bg-gradient-primary"
                                onClick={this.novoUsuario}>
                              <i className="fas fa-plus"></i> Adicionar</button>
                              &nbsp;
                              <input type="text" className="form-control" 
                                  placeholder="Consulte um usuário"
                                  value={this.state.consulta}
                                  onChange={e => this.setState({consulta: e.target.value})}
                                  onKeyDown={this.consultarGrupoPorNome}
                                  onKeyPress={event => event.key === 'Enter' && this.listarUsuarios()}/>
                              <span className="input-group-prepend">
                                  <span className="input-group-text">
                                  <i className="fas fa-search"></i>
                                  </span>
                              </span>
                            </span>
                          </div>
                        </div>
                        <Progresso classeSecundaria={this.state.classeDiv}/>
                        <ConfirmDialog visible={this.state.visible} 
                              onHide={() => this.setState({ visible: false })} 
                              message="Are you sure you want to proceed?"
                              header="Confirmation"
                              icon="pi pi-exclamation-triangle" 
                              accept={() => this.excluirUsuario} 
                              reject={() => this.setState({visible: false})}/>
                      </div>
                      <DataTable value={this.state.usuarios}  paginator responsiveLayout="scroll"
                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                          emptyMessage="Nenhum usuário encontrado">
                          <Column field="nome" header="Nome"></Column>
                          <Column field="email" header="E-Mail"></Column>
                          <Column field="perfil.nome" header="Perfil"></Column>
                          <Column field="dataCadastroCalculado" header="Data de Cadastro"></Column>
                          <Column key="codigo"></Column>
                          <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                      </DataTable>
                    </div>
                  </div>
                </div>
              </div>
            </section>
        </div>
      </>
    );
  }
}
Usuarios.contextType = AuthContext;
export default withRouter (Usuarios);